// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/payment.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.PaymentMethodConfig
 */
export const PaymentMethodConfig = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PaymentMethodConfig",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "provider_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "supported_currencies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "config", kind: "message", T: Struct },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.PaymentTransaction
 */
export const PaymentTransaction = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PaymentTransaction",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payment_method_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "provider_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "provider_reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "refunded_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "metadata", kind: "message", T: Struct },
    { no: 12, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "client_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "events", kind: "message", T: PaymentTransactionEvent, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.PaymentTransactionEvent
 */
export const PaymentTransactionEvent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PaymentTransactionEvent",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "raw_payload", kind: "message", T: Struct },
    { no: 5, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ConfigurePaymentMethodRequest
 */
export const ConfigurePaymentMethodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConfigurePaymentMethodRequest",
  () => [
    { no: 1, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "provider_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "supported_currencies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "config", kind: "message", T: Struct },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePaymentMethodRequest
 */
export const UpdatePaymentMethodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePaymentMethodRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "config", kind: "message", T: Struct },
    { no: 6, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeletePaymentMethodRequest
 */
export const DeletePaymentMethodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePaymentMethodRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPaymentMethodsRequest
 */
export const ListPaymentMethodsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPaymentMethodsRequest",
  () => [
    { no: 1, name: "active_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPaymentMethodsResponse
 */
export const ListPaymentMethodsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPaymentMethodsResponse",
  () => [
    { no: 1, name: "methods", kind: "message", T: PaymentMethodConfig, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreatePaymentSessionRequest
 */
export const CreatePaymentSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePaymentSessionRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_method_config_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "return_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "customer", kind: "message", T: Struct },
    { no: 7, name: "metadata", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.CreatePaymentSessionResponse
 */
export const CreatePaymentSessionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePaymentSessionResponse",
  () => [
    { no: 1, name: "transaction", kind: "message", T: PaymentTransaction },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "client_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CapturePaymentRequest
 */
export const CapturePaymentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CapturePaymentRequest",
  () => [
    { no: 1, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.RefundPaymentRequest
 */
export const RefundPaymentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RefundPaymentRequest",
  () => [
    { no: 1, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPaymentStatusRequest
 */
export const GetPaymentStatusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPaymentStatusRequest",
  () => [
    { no: 1, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTransactionsRequest
 */
export const ListTransactionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTransactionsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTransactionsResponse
 */
export const ListTransactionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTransactionsResponse",
  () => [
    { no: 1, name: "transactions", kind: "message", T: PaymentTransaction, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetTransactionRequest
 */
export const GetTransactionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTransactionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

